export const RewardsIcon = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <path
        d="M7,4.087,4.664.243A.425.425,0,0,0,4.264,0H.505A.5.5,0,0,0,.1.787L3.574,5.752A6.46,6.46,0,0,1,7,4.087ZM8,5a5.5,5.5,0,1,0,5.5,5.5A5.5,5.5,0,0,0,8,5ZM10.9,9.916,9.711,11.072,9.989,12.7a.357.357,0,0,1-.52.375L8,12.31l-1.465.768a.357.357,0,0,1-.52-.375L6.3,11.07,5.113,9.914a.361.361,0,0,1,.2-.614l1.637-.238.732-1.484a.357.357,0,0,1,.641,0l.734,1.484,1.637.238A.36.36,0,0,1,10.9,9.916ZM15.476,0H11.745a.5.5,0,0,0-.429.243L9.011,4.058a6.443,6.443,0,0,1,3.422,1.668L15.911.761A.488.488,0,0,0,15.476,0Z"
        transform="translate(1.995 2)"
      />
    </svg>
  );
};
